module.exports = __webpack_public_path__ + "static/media/dcbLogo.a1f81937.svg";